const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export interface HallOrderItem {
  name: string;
  amount: number;
  price: number;
  sum: number;
}

export interface HallOrder {
  id: string;
  status?: string;
  closed: boolean;
  sum: number;
  paid: number;
  remainder: number;
  guestsCount?: number;
  waiterName?: string;
  items: HallOrderItem[];
  canPayBill: boolean;
  canTip: boolean;
}

export interface HallTable {
  tableId: string;
  tableNumber: number | null;
  sectionName: string | null;
  order: HallOrder | null;
}

export interface HallPaymentStatus {
  id: string;
  kind: string;
  status: string;
  amount: number;
  tableId: string;
  tableNumber?: number | null;
  sectionName?: string | null;
  waiterName?: string | null;
  iikoOrderId: string | null;
  items?: HallOrderItem[];
}

async function readError(res: Response): Promise<string> {
  try {
    const data = await res.json();
    const msg = data?.message;
    if (Array.isArray(msg)) return msg.join(', ');
    return msg || data?.error || `Ошибка ${res.status}`;
  } catch {
    return `Ошибка ${res.status}`;
  }
}

export const hallApi = {
  async getTable(tableId: string): Promise<HallTable> {
    const res = await fetch(`${API_URL}/hall/table/${encodeURIComponent(tableId)}`);
    if (!res.ok) throw new Error(await readError(res));
    const json = await res.json();
    return json.data;
  },

  async getOrder(orderId: string): Promise<HallTable> {
    const res = await fetch(`${API_URL}/hall/order/${encodeURIComponent(orderId)}`);
    if (!res.ok) throw new Error(await readError(res));
    const json = await res.json();
    return json.data;
  },

  async payBill(body: { tableId?: string; orderId?: string }): Promise<{ paymentUrl: string; paymentId: string }> {
    const res = await fetch(`${API_URL}/hall/pay/bill`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await readError(res));
    return res.json();
  },

  async payTip(body: {
    tableId?: string;
    orderId?: string;
    amount: number;
  }): Promise<{ paymentUrl: string; paymentId: string }> {
    const res = await fetch(`${API_URL}/hall/pay/tip`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(await readError(res));
    return res.json();
  },

  async getPayment(id: string): Promise<HallPaymentStatus> {
    const res = await fetch(`${API_URL}/hall/payment/${encodeURIComponent(id)}`);
    if (!res.ok) throw new Error(await readError(res));
    const json = await res.json();
    return json.data;
  },
};
